module.exports = "<campaign-list (backMode)=\"openMode($event)\"  *ngIf=\"mode == 'list'\"></campaign-list>\r\n<campaign-detail *ngIf=\"mode == 'detail'\" (backMode)=\"openMode($event)\" [campaign_id]=\"choice_campaign_id\"></campaign-detail>"


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/pages/admin/icontact/campaign/campaign.template.html
// module id = ../../../../../src/app/pages/admin/icontact/campaign/campaign.template.html
// module chunks = main